import { AnimatePresence } from 'framer-motion';
import { useSessionContext } from '../../contexts/SessionProvider';
import SessionPermissionModal from '../CommonComps/Modals/SessionPermissionModal';

const SessionModalWrapper = () => {
  // integration of context hooks here
  const { micPermissions } = useSessionContext();

  // rendering session modal wrapper section component here
  return (
    <section>
      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {micPermissions?.state && micPermissions.state !== 'granted' ? (
          <SessionPermissionModal />
        ) : null}
      </AnimatePresence>
    </section>
  );
};

export default SessionModalWrapper;
